const styles = {
  container: {
    padding: "30px",
    background: "linear-gradient(135deg, #f9faff, #eef1f9)",
    minHeight: "100vh",
    transition: "margin-left 0.3s ease",
    fontFamily: "'Inter', sans-serif",
  },

  header: {
    fontSize: "2rem",
    fontWeight: "700",
    color: "#1B019B",
    marginBottom: "10px",
    textAlign: "center",
  },

  hr: {
    width: "80px",
    height: "4px",
    backgroundColor: "#1B019B",
    border: "none",
    borderRadius: "4px",
    margin: "0 auto 30px auto",
  },

  permissionsList: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "20px",
    marginTop: "20px",
  },

  permissionItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "15px 20px",
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    color: "#333",
    transition: "all 0.3s ease",
  },

  permissionItemHover: {
    transform: "translateY(-3px)",
    boxShadow: "0 6px 14px rgba(0, 0, 0, 0.08)",
  },

  submitButton: {
    marginTop: "35px",
    background: "linear-gradient(135deg, #1B019B, #4b28f5)",
    color: "#fff",
    border: "none",
    padding: "14px 35px",
    borderRadius: "40px",
    fontWeight: "bold",
    fontSize: "1.05rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    minWidth: "230px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },

  submitButtonHover: {
    background: "linear-gradient(135deg, #2c0dbb, #5d3ff5)",
    transform: "translateY(-2px)",
    boxShadow: "0 6px 14px rgba(0, 0, 0, 0.15)",
  },
};

export default styles;
